export function DPTransactionMapper(data) {
    let dpTransactions = new Array();
    let dpTransactionEntity = {
        dpTranactions: [],
    };
    if (data) {
        data.reduce((acc, record) => {
            dpTransactions.push(Object.assign(Object.assign({}, record), { accountCode: record.accCode }));
            return acc;
        }, []);
        dpTransactionEntity.dpTranactions = dpTransactions;
        return dpTransactionEntity;
    }
    else {
        return null;
    }
}
export function DPIdsMapper(data) {
    let dpIds = new Array();
    let dpTransactionEntity = {
        dpIds: [],
    };
    if (data) {
        data.reduce((acc, record) => {
            dpIds.push({ value: record.boId, display: record.boId });
            return acc;
        }, []);
        dpTransactionEntity.dpIds = dpIds;
        return dpTransactionEntity;
    }
    else {
        return null;
    }
}
